import React, { useEffect} from 'react'
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { userLogoutAction } from '../actions/userActions'
import { BASE_URL } from '../constants/urlConstants'
import { fetchCategory } from '../actions/productActions'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { fetchLogo } from '../actions/logoActions'
function Header() {

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const listCategory = useSelector(state => state.listCategory)
  const { errorOfcategory, loadingOfcategory, categories } = listCategory

  const listLogoImage = useSelector(state => state.listLogoImage)
  const { errorOflogoImage, loadingOflogoImage, logoImage } = listLogoImage
  
    const error=false
    const loading=false
  if(errorOfcategory){
    error = errorOfcategory
  }else if(errorOflogoImage){
    error = errorOflogoImage
  }
  if(loadingOfcategory || loadingOflogoImage){
    loading = true
  }

  const dispatch = useDispatch()

  const logoutHandler = () => {
    dispatch(userLogoutAction())
  }

  useEffect(() => {
      dispatch(fetchCategory())
      dispatch(fetchLogo())
    }, [])

  return (

    
     <header>

      <div className='rednegin left'>
        <div>
        <div className='left divround' >
          <img className='qlt'
            src={`${BASE_URL}/public/images/logo/aaa.png`}
            alt=""
          />
        </div>
        </div>
      </div>
      {loading ? <Loader />
        : error ? <Message variant='danger' text={error} />
         : <Navbar className='bg-light' variant='light' expand="lg" collapseOnSelect >
            <Container>
              <img
                src={`${BASE_URL}/${logoImage.logoHeaderImage}`}
                alt=""
                style={{
                  width: "auto", // عرض عکس
                  height: "35px", // ارتفاع عکس
                  padding: "0",
                  marginRight: "10%",
                  objectFit: 'fill',
                }}
              />
            </Container>
            <Container className='center'>
    
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">

                <LinkContainer to="/">
                <Navbar.Brand >صفحه اصلی</Navbar.Brand>
              </LinkContainer>

                <NavDropdown title={<span className="fw-bold">محصولات</span>} id="products">
                {categories.map(category => (
                      <LinkContainer to={`/products/${category._id}`}>
                        <NavDropdown.Item >{category.title}</NavDropdown.Item>
                      </LinkContainer>
                ))}
                     
                    </NavDropdown>

                  <LinkContainer to={{ pathname: "/mainpage", search: "?filter=contactus" }}>
                    <Navbar.Brand >ارتباط با ما</Navbar.Brand>
                  </LinkContainer>
                  <LinkContainer to={{ pathname: "/mainpage", search: "?filter=aboutus" }}>
                    <Navbar.Brand >درباره ما</Navbar.Brand>
                  </LinkContainer>
                  <LinkContainer to={{ pathname: "/orders", search: "?filter=orders" }}>
                    <Navbar.Brand >فروش کیت</Navbar.Brand>
                  </LinkContainer>
                  {userInfo ? (
                    <NavDropdown title={userInfo.name} id="username">
                      <LinkContainer to="/profile">
                        <NavDropdown.Item >پروفایل</NavDropdown.Item>
                      </LinkContainer>
                      <NavDropdown.Divider />
                      <NavDropdown.Item onClick={logoutHandler} >خروج</NavDropdown.Item>
                    </NavDropdown>
                  ) : (
                    <LinkContainer to="/login">
                      <Navbar.Brand ><i className="fas fa-user"></i>ورود</Navbar.Brand>
                    </LinkContainer>
                  )}
                </Nav>
              </Navbar.Collapse>

              


            </Container>
            <Container className='left'>
             
            </Container>
          </Navbar>
}

    </header>
                
  )
}

export default Header
